import { SyntheticEvent, useEffect, useState } from 'react';

import { SliderContainer, SliderInput } from './Slider.style';

export interface SliderProps {
  id?: string;
  name?: string;
  value: number;
  min?: number;
  max?: number;
  step?: number;
  onChange: (value: number) => void;
  onChangeEnd?: (event: SyntheticEvent) => void;
}

export function Slider({
  id,
  name,
  value: initialValue,
  onChange,
  onChangeEnd = () => {
    return;
  },
  min = 0,
  max = 100,
  step = 1,
}: SliderProps) {
  const [minValue, setMinValue] = useState(min);
  const [maxValue, setMaxValue] = useState(max);
  const [value, setValue] = useState(initialValue);

  useEffect(
    function updateValuesWhenPropChanges() {
      setMinValue(min);
      setMaxValue(max);
      setValue(initialValue);
    },
    [initialValue, max, min]
  );

  return (
    <SliderContainer>
      <SliderInput
        type="range"
        min={minValue}
        max={maxValue}
        step={step}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        onMouseUp={onChangeEnd}
        {...(id ? { id } : {})}
        {...(name ? { name } : {})}
      />
    </SliderContainer>
  );
}
